import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { PdfData } from "../models";

@Injectable({
    providedIn: "root",
})

export class InvoicePreviewService {
    //Hold latest PDF blob 
    private pdfBlobSubject = new BehaviorSubject<PdfData | null>(null);

    //Observalbe for components to subscribe to PDF blob changes
    pdfBlob$ = this.pdfBlobSubject.asObservable();

    // Update the current PDF blob
    setPdfBlob(pdfData: PdfData) {
        this.pdfBlobSubject.next(pdfData);
    }

    // Clear the current PDF blob
    clearPdfBlob() {
        this.pdfBlobSubject.next(null);
    }
}